// src/modules/rituales-skeleton.js — placeholders del embed de rituales del home.
//
// FASE 4 · Bug #1 (skeleton + caché). El guardian (guardian-home-rituales.js)
// inyecta este skeleton en el slot del embed APENAS aparece el home, y lo
// reemplaza por las cards reales cuando resuelve renderRitualesGrupo (async).
// El skeleton ES el estado de carga — no hay texto "Cargando…" visible.
//
// HTML puro, sin dependencias — testeable de forma aislada. Reusa las
// variables CSS del theme (no introduce paleta nueva); el único agregado es
// una animación de pulse sutil, scopeada por la clase .ritual-skel-pulse.

// Skeleton: imita la grilla de 3 columnas de cards cuadradas de arengas
// (mismo tamaño y posición que las cards reales → sin salto de layout).
export const buildRitualesSkeleton = () => `
    <style>
        @keyframes ritualSkelPulse { 0%, 100% { opacity: .5; } 50% { opacity: .9; } }
        .ritual-skel-pulse { animation: ritualSkelPulse 1.25s ease-in-out infinite; }
    </style>
    <div style="display:flex;align-items:center;gap:.5rem;margin-bottom:.6rem;">
        <span style="font-size:1.05rem;">⚽</span>
        <strong style="color:var(--white);font-size:.92rem;">Rituales del grupo</strong>
    </div>
    <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:.48rem;">
        ${[0, 1, 2].map(() => `
            <div class="ritual-skel-pulse" data-rituales-skeleton-card style="aspect-ratio:1;border-radius:10px;border:1px solid var(--glass-border);background:rgba(255,255,255,.045);padding:.55rem;display:flex;flex-direction:column;justify-content:space-between;">
                <span style="width:34px;height:34px;border-radius:11px;background:rgba(255,255,255,.085);"></span>
                <span style="display:flex;flex-direction:column;gap:.32rem;">
                    <span style="height:.58rem;width:82%;border-radius:4px;background:rgba(255,255,255,.085);"></span>
                    <span style="height:.5rem;width:56%;border-radius:4px;background:rgba(255,255,255,.06);"></span>
                    <span style="height:.5rem;width:42%;border-radius:4px;background:rgba(117,170,219,.2);"></span>
                </span>
            </div>
        `).join('')}
    </div>
`;

// Estado de error suave — sin clobber del home; ofrece reintentar.
export const buildRitualesError = () => `
    <div class="glass-card" style="padding:1rem;text-align:center;border-color:rgba(255,255,255,.1);">
        <p style="color:var(--text-muted);font-size:.84rem;margin:0 0 .65rem;">No pudimos cargar los rituales del grupo.</p>
        <button class="btn btn-secondary" type="button" data-rituales-retry style="width:auto;margin:0;padding:.42rem .95rem;font-size:.8rem;">Reintentar</button>
    </div>
`;
